/* istanbul ignore file */
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { AppConstants, dashboardRouteWithSlash, StorageService } from 'src/app/core/core';
import { ADPResourceService } from 'digital-core';

@Injectable({
  providedIn: 'root',
})
export class HomeGuard {
  constructor(
    private storageService: StorageService,
    private router: Router,
    private resourceService: ADPResourceService,
  ) {
  }

  async canActivate(_route: ActivatedRouteSnapshot, _state: RouterStateSnapshot) {
    const plansCount = Number(this.storageService.getLocal<string>(AppConstants.STORAGE_KEYS.PlansCount) || '0');
    const isSelectHomeEnabled = this.resourceService.getPortalSetting('Global_SelectHome_Enabled')?.Value?.toLowerCase() !== 'false';

    if (plansCount > 1 && isSelectHomeEnabled) {
      return true;
    }
    else {
      this.router.navigate([dashboardRouteWithSlash]);
      return false;
    }
  }
}
